var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScheduleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    color: "white",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.29402 12.7109V5.09007C4.29402 4.22749 4.97635 3.52101 5.81076 3.52101H27.9168C28.7504 3.52101 29.4335 4.22749 29.4335 5.09007V23.3209C29.4335 24.1835 28.6217 24.902 27.788 24.902H19.2926M9.20878 1.77734V5.41675M14.3118 1.77734V5.41675M19.4149 1.77734V5.41675M24.518 1.77734V5.41675M4.29321 7.63596H29.4327M2.06836 21.6649H3.88848M9.52822 29.1578V27.3377M17.0211 21.6979H15.201",
    stroke: "currentColor",
    strokeWidth: 1.1265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68309 23.9041L9.50194 21.7002M9.54619 21.6825L9.57032 16.0789M17.2265 21.7002C17.2265 17.4339 13.7682 13.9756 9.50194 13.9756C5.23571 13.9756 1.77734 17.4339 1.77734 21.7002C1.77734 25.9664 5.23571 29.4248 9.50194 29.4248C13.7682 29.4248 17.2265 25.9664 17.2265 21.7002Z",
    stroke: "currentColor",
    strokeWidth: 1.1265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleWhite);
export default __webpack_public_path__ + "static/media/schedule-white.15bbbc9863932e74caf3875a672e5d8c.svg";
export { ForwardRef as ReactComponent };